import {
  commitCustomHighlights,
  CustomHighlightOptions,
} from "@/features/experience-highlights/lib/commit-custom-highlights";
import { allCustomHighlights } from "@/features/experience-highlights/lib/get-all-custom-highlights";
import { ExperienceTranslationV2 } from "@/types/generated/ContentCommandApi";
import { useContentCommandApi } from "@/composables/useContentCommandApi";
import { ExperienceFlowCode, ExperienceStatusCode } from "@/types/DocumentStatuses";

/** Maps each `allCustomHighlights` key to the `HighlightsKey` used by `commitCustomHighlights`. */
const customKeyToHighlightKey = {
  custom_highlights: "highlights",
  custom_important_information: "important_information",
  custom_included: "included",
  custom_non_included: "non_included",
} as const;

export async function updateTranslation(
  translationId: string,
  updatedValues: {
    translation: ExperienceTranslationV2;
    /** Only the keys present here are committed. */
    highlights: Partial<allCustomHighlights>;
  }
) {
  const { putTranslation } = useContentCommandApi();
  const { highlights, translation } = updatedValues;

  const highlightOptions: CustomHighlightOptions = {
    curationFlowCode: translation.flow_code as ExperienceFlowCode,
    toBeEditedStatusCode: translation.status_code as ExperienceStatusCode,
  };

  const translationUpdatePromise = putTranslation(`experience-translations/${translationId}`, translation);

  const customHighlightPromises = (Object.keys(customKeyToHighlightKey) as Array<keyof allCustomHighlights>)
    .filter((customKey) => highlights[customKey] != null)
    .map((customKey) =>
      commitCustomHighlights(
        translation.experience_id,
        customKeyToHighlightKey[customKey],
        highlights[customKey] ?? [],
        highlightOptions
      )
    );

  return Promise.all([translationUpdatePromise, ...customHighlightPromises]);
}
